import { mapGetters } from 'vuex';
import tallyTests from '~/mixins/tallyTests';

export default {
  mixins: [tallyTests],
  methods: {
    showInput(inputData, formName, calculatingSteps = false) {
      if (!inputData) {
        return false;
      }
      const debug = 0;
      let showInput = true;
      for (let iter = 0; iter < inputData.dependencies.length; iter++) {
        const input = inputData.dependencies[iter];
        if (debug) {
          console.log('SHOWINPUT checkujem', inputData.id, input);
        }
        if (input.dependencyFormInputId) {
          // find dependency input
          const depInput = this.findInputById(input.dependencyFormInputId, formName);

          // check if dependency is set
          if (this.showInput(depInput, formName, calculatingSteps)) {
            if (debug) {
              console.log('SHOWINPUT dependency show input je TRUE');
            }
            if (calculatingSteps && this.responses[formName][depInput.id] === undefined) {
              // when calculating steps, we need to skip dependencies without answers because we can not decide if we should show or hide question
              continue;
            }

            if (input.dependencyFormInputValue === null) {
              if (this.responses[formName][depInput.id]) {
                continue;
              } else {
                showInput = false;
                break;
              }
            } else {
              if (debug) {
                console.log('SHOWINPUT kontrolujem DEP hodnotu');
              }
              if (
                this.responses[formName][depInput.id] &&
                ((input.operator === '=' &&
                  this.checkEqual(depInput, input.dependencyFormInputValue, formName)) ||
                  (input.operator === '<>' &&
                    this.checkNotEqual(depInput, input.dependencyFormInputValue, formName)) ||
                  (input.operator === '<' &&
                    this.checkSmaller(depInput, input.dependencyFormInputValue, formName)) ||
                  (input.operator === '>' &&
                    this.checkBigger(depInput, input.dependencyFormInputValue, formName)))
              ) {
                if (debug) {
                  console.log('SHOWINPUT DEP hodnota OK');
                }
                continue;
              } else {
                if (debug) {
                  console.log('SHOWINPUT DEP hodnota FALSE');
                }
                showInput = false;
                break;
              }
            }
          } else {
            if (debug) {
              console.log('SHOWINPUT DEP parent show input FALSE');
            }
            showInput = false;
            break;
          }
        }
      }
      if (debug) {
        console.log('SHOWINPUT returning', showInput);
      }
      return showInput;
    },

    findInputById(id, formName) {
      // console.log('FORM NAME IN FIND INPUT BY ID', formName)
      let depInput = null;
      if (this.forms[formName]?.formSteps !== undefined) {
        this.forms[formName].formSteps.forEach(step => {
          if (!depInput) {
            depInput = step.formInputs.find(val => val.id === id);
          }
        });
      }
      return depInput;
    },

    checkEqual(depInput, valueToCheck, formName) {
      if (Array.isArray(this.responses[formName][depInput.id])) {
        return !!this.responses[formName][depInput.id].find(val => val.toString() === valueToCheck);
      } else {
        return this.responses[formName][depInput.id].toString() === valueToCheck;
      }
    },

    checkNotEqual(depInput, valueToCheck, formName) {
      return this.responses[formName][depInput.id].toString() !== valueToCheck;
    },

    checkSmaller(depInput, valueToCheck, formName) {
      if (depInput.formInputType === 'date') {
        const depDate = new Date(this.responses[formName][depInput.id]);
        const checkDate = new Date(valueToCheck);
        return depDate < checkDate;
      } else {
        return parseFloat(this.responses[formName][depInput.id]) < parseFloat(valueToCheck);
      }
    },

    checkBigger(depInput, valueToCheck, formName) {
      if (depInput.formInputType === 'date') {
        const depDate = new Date(this.responses[formName][depInput.id]);
        const checkDate = new Date(valueToCheck);
        return depDate > checkDate;
      } else {
        return parseFloat(this.responses[formName][depInput.id]) > parseFloat(valueToCheck);
      }
    },

    dependentInputs(originalInput, originalValue, formName) {
      const dependentInputs = [];

      this.forms[formName].formSteps.forEach(step => {
        step.formInputs.forEach(stepInput => {
          stepInput.dependencies.forEach(inputDep => {
            // console.log('inputDep.dependencyFormInputValue',inputDep.dependencyFormInputValue)
            // console.log('originalValue',originalValue)
            // if (originalInput.id == 83 && inputDep.dependencyFormInputId === originalInput.id){
            //   console.log('inputDep.dependencyFormInputId === originalInput.id',inputDep.dependencyFormInputId === originalInput.id)
            //   console.log('[\'after_value\', \'subquestion\'].indexOf(inputDep.dependencyType) !== -1',['after_value', 'subquestion'].indexOf(inputDep.dependencyType) !== -1)
            //   console.log('this.responses[formName][inputDep.dependencyFormInputId]',this.responses[formName][inputDep.dependencyFormInputId], this.responses[formName], inputDep.dependencyFormInputId)
            //   console.log('(inputDep.operator === \'=\' && inputDep.dependencyFormInputValue === originalValue)',(inputDep.operator === '=' && inputDep.dependencyFormInputValue === originalValue), inputDep.operator, inputDep.dependencyFormInputValue, originalValue)
            //   console.log('------------------')
            // }
            if (
              inputDep.dependencyFormInputId === originalInput.id &&
              ['after_value', 'subquestion'].indexOf(inputDep.dependencyType) !== -1 &&
              this.responses[formName][inputDep.dependencyFormInputId] &&
              inputDep.operator === '=' &&
              inputDep.dependencyFormInputValue.toString() === originalValue.toString()
            ) {
              dependentInputs.push(stepInput);
            }
          });
        });
      });

      // console.log('DEP INPUT', originalInput, originalInput.id, originalValue, dependentInputs)

      return dependentInputs;
    },

    validateStep(formInputs) {
      // return true
      let isValid = true;
      // console.log('VALIDUJEM', formInputs, this.currentStepData, this.responses[this.formName], this.validations[this.formName], this.currentStep)
      formInputs.forEach(input => {
        if (
          input.required &&
          this.showInput(input, this.formName) &&
          ((input.formInputType === 'file_id' &&
            (!this.attachments[this.formName][input.id] ||
              !this.attachments[this.formName][input.id].length)) ||
            (input.formInputType !== 'file_id' &&
              (!this.validations[this.formName][input.id] ||
                this.responses[this.formName][input.id] === null ||
                this.responses[this.formName][input.id] === undefined ||
                this.validations[this.formName][input.id] === false)))
        ) {
          // console.log('vraciam FALSE z required', input.id, this.validations[this.formName][input.id], this.responses[this.formName][input.id])
          isValid = false;
        } else if (
          this.responses[this.formName][input.id] !== null &&
          this.responses[this.formName][input.id] !== undefined
        ) {
          // if (!this.validateDependencyInputs(input)) {
          //   isValid = false
          // }
        }
      });
      // console.log('VRACIAM', isValid)
      return isValid;
    },

    checkRoute(query, isDialog = false) {
      if (query.step && query.dfn === this.formName) {
        if (!this.canShowStep(+query.step)) {
          this.$store.commit('dynamicForms/updateCurrentStep', {
            formName: this.formName,
            step: 1
          });
          this.updateRoute(this.formName, 1);
        } else if (+query.step !== this.$store.state.dynamicForms.currentSteps[this.formName]) {
          this.$store.commit('dynamicForms/updateCurrentStep', {
            formName: this.formName,
            step: +query.step
          });
        }
        if (isDialog) {
          this.$store.commit('dynamicForms/updateFormDialogs', {
            formName: this.formName,
            value: true
          });
        }
      } else if (isDialog) {
        if (this.$store.getters['dynamicForms/loading'][this.formName] === false) {
          this.$store.commit('dynamicForms/updateFormDialogs', {
            formName: this.formName,
            value: false
          });
        }
      }
    },

    canShowStep(step) {
      let isValid = true;
      let phoneVerificationStep = false;
      for (let iter = 0; iter < this.possibleSteps.length; iter++) {
        if (
          this.possibleSteps[iter].settings.number >= step ||
          !isValid ||
          this.possibleSteps[iter].type === 'static'
        ) {
          break;
        }
        if (phoneVerificationStep && !this.$auth.user.verify.phone) {
          isValid = false;
          break;
        }
        if (this.possibleSteps[iter].phoneVerificationInput) {
          phoneVerificationStep = true;
        }
        isValid = this.validateStep(this.possibleSteps[iter].settings.formInputs);
      }
      return isValid;
    },

    async updateRoute(formName = this.formName, step = this.currentStep) {
      const query = { ...this.$route.query };
      if (formName) {
        query.dfn = formName;
      } else {
        delete query.dfn;
      }
      if (step) {
        query.step = step;
      } else {
        delete query.step;
      }

      if (this.isMobileApp) {
        if (!query.dfn) {
          await this.$router.push(this.dialogFrom || this.$localePath('dashboard'));
        } else {
          await this.$router.push(
            this.$localePath({
              name: 'profileDialog',
              query,
              params: { ...this.$route.params, savePosition: true }
            })
          );
        }
      } else {
        await this.$router.push(
          this.$localePath({
            name: this.currentPath,
            query,
            params: { ...this.$route.params, savePosition: true }
          })
        );
      }
    },

    async checkUrlForDynamicForm() {
      const dynamicFormName = this.$route.query?.dfn;
      const redirectTargets = {
        Question: 'questions',
        Order: 'appointments',
        Appointment: 'appointments'
      };

      if (dynamicFormName && redirectTargets[dynamicFormName]) {
        const sanitizedQuery = { ...this.$route.query };
        delete sanitizedQuery.dfn;
        delete sanitizedQuery.step;

        const targetPath = this.$localePath({
          name: redirectTargets[dynamicFormName],
          query: sanitizedQuery
        });

        if (this.$route.fullPath !== targetPath) {
          await this.$router.replace(targetPath);
        }
        return;
      }

      if (this.$auth.user.verify.email && dynamicFormName && dynamicFormName.length) {
        await this.$store.dispatch('dynamicForms/updateFormDialogs', {
          formName: dynamicFormName,
          value: true
        });

        const tallyFormAvailable = this.tallyFormsAvailable.find(
          test => test.formName === dynamicFormName
        );
        if (tallyFormAvailable) {
          this.sendEvaluationsAnalyticsStart(
            tallyFormAvailable.formName,
            tallyFormAvailable.internalName
          );
        }
      }
    }
  },
  computed: {
    showNavigationButton() {
      return this.currentStepData?.settings?.formInputs
        ? !this.currentStepData.settings.formInputs.find(val => val.continueOnAnswer)
        : true;
    },
    possibleSteps() {
      const possibleSteps = [];

      if (!this.internalForms[this.formName]) {
        return possibleSteps;
      }

      if (this.internalForms[this.formName] && this.internalForms[this.formName].length) {
        this.internalForms[this.formName].forEach(step => {
          if (step.type === 'static') {
            possibleSteps.push(step);
            if (step.phoneVerificationInput && !this.$auth.user.verify.phone) {
              possibleSteps.push({
                type: 'static',
                settings: {
                  cmp: 'PhoneVerification',
                  showHeader: true
                },
                dialogDataStore: 'profile/phoneVerification',
                showLeftDialogIcon: true
              });
            }
            return;
          }
          let possible = false;

          step.settings.formInputs.forEach(input => {
            if (!possible && this.showInput(input, this.formName, true)) {
              possible = true;
            }
          });
          if (possible) {
            possibleSteps.push(step);
          }
          if (step.phoneVerificationInput && !this.$auth.user.verify.phone) {
            possibleSteps.push({
              type: 'static',
              settings: {
                cmp: 'PhoneVerification',
                showHeader: true
              },
              dialogDataStore: 'profile/phoneVerification',
              showLeftDialogIcon: true
            });
          }
        });
      }

      // filter only steps with unique number
      const usedNumbers = [];
      const posSteps = possibleSteps.filter(val => {
        if (val.settings.number === undefined) {
          // always return static steps without number
          return true;
        }
        if (usedNumbers.indexOf(val.settings.number) === -1) {
          usedNumbers.push(val.settings.number);
          return true;
        }
        return false;
      });
      return posSteps;
    },

    currentStep() {
      return this.currentSteps[this.formName];
    },

    currentStepData() {
      return this.possibleSteps[this.currentStep - 1];
    },

    ...mapGetters({
      responses: 'dynamicForms/responses',
      attachments: 'dynamicForms/attachments',
      forms: 'dynamicForms/forms',
      internalForms: 'dynamicForms/internalForms',
      validations: 'dynamicForms/validations',
      currentSteps: 'dynamicForms/currentSteps',
      dialogFrom: 'profile/dialogPage/dialogFrom'
    })
  }
};
